module.exports = __webpack_public_path__ + "img/selected2-min.bb98f39c.png";